import styled from 'styled-components';

const SectionContainer = styled.div`
  max-width: 1480px;
  position: relative;
  width: 100%;
  padding: 0 20px;
  margin: 0 auto;
  ${({ zIndex }) => zIndex !== undefined && `z-index: ${zIndex}`};
`;

export default SectionContainer;
